<template>
  <div class="term-and-condition">
    <div class="term-and-condition-text">
      <p>
        Your personal data will be used to process your order, support your experience throughout this website, and for other purposes described in our
        <a
          href="javascript:void(0)"
          @click="openPrivacyPolicy"
        >privacy policy</a>.
      </p>
      <label>
        <input type="checkbox" name="terms" id="terms" />
        <span>
          I have read and agree to the website
          <a
            href="javascript:void(0)"
            data-toggle="modal"
            data-target=".tac-modal"
          >terms and conditions</a>
        </span>
        <span class="required">*</span>
      </label>
    </div>

    <div class="modal fade tac-modal" tabindex="-1" role="dialog" aria-hidden="true">
      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
        <img
          class
          src="https://www.truelifecare.org/wp-content/uploads/cp_modal/modal_home_page_vimeo_cp_id_3ecf6/cross.png"
          alt="close-link"
        />
      </button>
      <div class="modal-dialog">
        <policy />
      </div>
    </div>
  </div>
</template>
<script>
import Policy from '@/components/Policy'
export default {
  components: {
    Policy
  },
  methods: {
    openPrivacyPolicy() {
      let routeData = this.$router.resolve({ name: 'privacyPolicy' })
      window.open(routeData.href, '_blank')
    }
  }
}
</script>
